<template>
  <div class="login-background">
    <div class="logoLeft"></div>
    <div class="login-info" >
      <div class="login-form-background" style="right: 300px;">
        <div>
          <div class="title"></div>
          <div style="align-items: center;color: #29387b;font-size: 28px;width: 100%;text-align:center;font-family: 'Microsoft YaHei';font-weight: bold">
            燃气报警监控云平台
          </div>
          <p style="font-size: 14px;color:#bdc2da;text-align: center">Gas alarm monitoring cloud platform</p>
          <div class="login-form">
            <div class="login-input">
              <input class="username" v-model="username" type="text" placeholder="请输入账号" @keyup.enter="login">
            </div>
            <div class="login-input">
              <input class="password" v-model="password" type="password" placeholder="请输入密码" @keyup.enter="login">
            </div>
            <div class="login-input">
              <div class="login-a"
                style="width: 300px;display: flex;justify-content: space-between;margin-bottom: 20px;font-size: 12px;color:#9EA5AD">
                <!-- <div>自动登录</div>
                <div>找回密码？</div> -->
              </div>
            </div>
            <div class="login-button">
              <button @click="login">
                登&nbsp;录
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-text">
		<div style="width:100%;"><a target="_blank" href="http://beian.miit.gov.cn/">沪ICP备2022027423号-1</a></div>
    </div>
  </div>
</template>

<script>

  import CommonJs from '@/assets/js/common/common.js'
  export default {
    name: 'login',
    data() {
      return {
        username: '',
        password: '',
        qrCodeShow: false,
        width: '0',
        telephone: '',
        mail: '',
        address: ''
      }
    },
    methods: {
      login() {
        const data = {
          username: this.username,
          password: this.password
        };
        if(data.username == ''){
          this.utils.messageAlert("请填写用户名", "登录失败", "确定");
          return;
        }
        if(data.password == ''){
          this.utils.messageAlert("请填写密码", "登录失败", "确定");
          return;
        }
        CommonJs.login(data).then((response) => {
		  //alert(response);
          const data = response.data;
          if (data.data.res == 1) {
            this.$store.commit('setSessionId', data.data.SessionId);
            this.$store.commit('setUserInfo', data.data.currentUser);
            this.$store.commit('setMenuPermission', data.data.menus);
            localStorage.setItem("LoginName", this.username);
            sessionStorage.setItem('store', JSON.stringify(this.$store.state))
            CommonJs.getMenu().then((response1) => {
              const data1 = response1.data;
              this.$router.push({
                path: '/static/map'
              });
            }).catch((response) => {
            })
          } else {
            this.utils.messageAlert(data.data.msg, "登录失败", "确定");
          }
        }).catch((response) => {
          this.utils.messageAlert("登录失败", "登录失败", "确定");
        })
      },
    },
    created() {
      this.username = localStorage.getItem("LoginName");
      if (sessionStorage.getItem('store')) {
        this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
      }
    }
  }
</script>

<style scoped>
  .login-background {
    position: absolute;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .login-info {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: right;
    background: url(../../assets/img/login/backgroundYz.png) no-repeat;
    background-size: auto;
    align-items: center;
    flex-wrap: nowrap;
    padding-right: 150px;
  }

  .login-form-background {
    position: relative;
    width: 380px;
    height: 500px;
    background: white;
    border-radius: 5px;
  }
  .login-form-background .title{
    width: 100%;
    text-align: center;
    height: 90px;
    background: url(../../assets/img/login/login_text.png) no-repeat center;
    margin: 20px 0;
  }
  .login-form {
    height: 290px;
    width: 100%;
    margin-top: 30px;
  }

  .login-block {}

  .login-title {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 60px;
  }

  .login-title img {
    width: 45px;
    height: 45px;
    margin-right: 12px;
  }

  .login-input {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .login-input .username {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 32px;
  }

  .login-input .password {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }

  .login-input input {
    width: 300px;
    height: 50px;
    padding-left: 40px;
    background-color: #f1f3f7;
    background-repeat: no-repeat;
    background-position: center left;
    background-position-x: 10px;
    background-size: 20px 20px;
    font-size: 18px;
    display: flex;
    align-items: center;
    border: 0;
    font-family: "Microsoft YaHei";
  }

  input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #dcdde2;
  }

  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #dcdde2;
  }

  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #dcdde2;
  }

  input:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #dcdde2;
  }

  .login-button {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 10px;
  }

  .login-button button {
    text-align: center;
    font-size: 18px;
    color: #FFFFFF;
    width: 300px;
    height: 50px;
    border: none;
    background: linear-gradient(to right, #0E9A90, #48D684);
    cursor: pointer;
    border-radius: 5px;
  }

  .bottom-text {
    font-size: 12px;
    color: #222223;
    position: absolute;
    width: 100%;
    height: 50px;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  .bottom-text div {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .bottom-text a {
    font-size: 12px;
    color: #fff;
    text-decoration: none;
  }
  .logoLeft{
    position: absolute;
    left: 70px;
    top: 70px;
    width: 343px;
    height: 36px;
    background: url(../../assets/img/login/logo_text.png) no-repeat center;
    z-index: 100;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue